import React from 'react'

import { faCalendarAlt, faClipboardCheck, faLockAlt, faPlusCircle } from '@fortawesome/pro-regular-svg-icons'
import { List } from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { AuthShieldComponent } from 'components/AuthShield'
import { FEATURE_NAMES } from 'components/ConfiguredDynamicFeatureProvider/features'
import DynamicFeature from 'components/DynamicFeatureProvider/DynamicFeature'
import { hasHighSchool } from 'store/user'

import SidebarListItem from './SidebarListItem'

/**
 * This component displays links in the top-nav sidebar
 * @param {object} props
 * @prop {string} pathname
 * @returns Component displaying list of links for sidebar
 */
const PagesList = ({ pathname, hasHighSchool }) => {
  const root = import.meta.env.BASE_URL
  return (
    <List>
      <DynamicFeature name={FEATURE_NAMES.Visits}>
        <AuthShieldComponent
          id="main-nav-events-and-deadlines"
          label="Visits & Deadlines"
          to={`${root}/events`}
          component={SidebarListItem}
          pathname={pathname}
          propsAuthed={{
            icon: faCalendarAlt,
          }}
          propsUnauthed={{
            disabled: true,
            icon: faLockAlt,
          }}
        />
      </DynamicFeature>
      <DynamicFeature name={FEATURE_NAMES.Surveys}>
        {hasHighSchool && (
          <AuthShieldComponent
            id="main-nav-surveys"
            label="Surveys"
            component={SidebarListItem}
            to={`${root}/surveys`}
            pathname={pathname}
            propsAuthed={{
              icon: faClipboardCheck,
            }}
            propsUnauthed={{
              disabled: true,
              icon: faLockAlt,
            }}
          />
        )}
      </DynamicFeature>
      <SidebarListItem
        id="main-nav-compare-colleges"
        icon={faPlusCircle}
        label="Compare Colleges"
        to={`${root}/college-compare`}
        pathname={pathname}
      />
    </List>
  )
}

PagesList.propTypes = {
  pathname: PropTypes.string,
  hasHighSchool: PropTypes.bool,
}

export default connect((store) => {
  return {
    hasHighSchool: hasHighSchool(store),
  }
})(PagesList)
